// TWO COMPONENTS: a report's rows, and the list of dashboards. Every other entry came across in
// the clone from t5 and named a component that is not here -- a registry of things that do not
// exist is a build error at best and a silent undefined at worst.
import DashboardEnterpriseComponent from "./ec/impl/Reporting/DashboardEnterpriseComponent";
import ReportResultEnterpriseComponent from "./ec/impl/Reporting/ReportResultEnterpriseComponent";

const enterpriseComponentClasses: Map<string, object> = new Map();
// A name this factory does not know returns undefined, and makeEnterpriseComponent then calls
// `new undefined()` -- so a missing registration is a blank page, not a missing feature.
// The reporting tree is a GUEST in t5 and leaves for t10; this registration is one of the few
// lines outside components/Reporting that has to come out with it.
enterpriseComponentClasses.set("ReportResultEnterpriseComponent", ReportResultEnterpriseComponent);
enterpriseComponentClasses.set("DashboardEnterpriseComponent", DashboardEnterpriseComponent);

export default function enterpriseComponentClassFactory(name: string): object | undefined{
    return enterpriseComponentClasses.get(name + "EnterpriseComponent");
}